const frontendURL = '/cat/personcontragent/';
const backendURL = '/api/references/refpersoncontragent/';
const name = 'Уповноважена особа контрагента';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
